import { useLocale } from '@plandi/common'
import { AxiosError } from 'axios'
import { useMutation, UseMutationOptions } from 'react-query'
import { profileSpecialistApi } from '..'

export type showIds = number[]

export const useMutationShowSimilar = (
  options?: UseMutationOptions<unknown, AxiosError, showIds>
) => {
  const locale = useLocale()
  const mutation = useMutation(
    async (showIds) =>
      await profileSpecialistApi.showSimilar({ ids: showIds }, locale),
    {
      ...options
    }
  )

  return mutation
}
